/**
 * "Put Yoink on your phone" invitation card (default-app wave 2, step 7).
 *
 * Renders ONLY for a signed-in explorer on a phone/tablet browser —
 * never on desktop, never inside the installed app, never after the app
 * was installed on this device, never after a dismissal. Per-device
 * memory is correct here: installing on a phone doesn't put Yoink on
 * the iPad (see core/device.js). The full page at /adventure/phone
 * stays reachable for everyone via Help.
 */
import { isMobile, isAndroid, isStandalone, appInstalled } from '../core/device.js';

export const PHONE_CARD_DISMISSED_KEY = 'yoink_phone_card_dismissed';

function dismissed() {
  try {
    return localStorage.getItem(PHONE_CARD_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissPhoneCard() {
  try {
    localStorage.setItem(PHONE_CARD_DISMISSED_KEY, '1');
  } catch { /* private mode — it shows again next visit */ }
}

export function phoneCardHtml(state) {
  if (!state?.user) return '';
  if (!isMobile() || isStandalone() || appInstalled() || dismissed()) return '';
  const device = isAndroid() ? 'phone' : (/ipad|macintosh/i.test(navigator.userAgent) ? 'iPad' : 'iPhone');
  const pitch = isAndroid()
    ? 'One tap, and Yoink opens full-screen — and shows up when you share a place from Google Maps.'
    : 'Full-screen from your Home Screen, and a shortcut that saves places from your share sheet.';
  return `
    <section class="phone-card" aria-label="Put Yoink on your ${device}">
      <span class="phone-card-body"><strong>Add Yoink to your ${device}</strong> — ${pitch}</span>
      <span class="phone-card-actions">
        <button type="button" class="v2-btn-more" data-phone-card-open>Show me</button>
        <button type="button" class="phone-card-close" data-phone-card-dismiss
          aria-label="Don’t show this again">✕</button>
      </span>
    </section>`;
}
